import { styled, css, keyframes } from "styled-components";
import { Box, Card, Typography, Stack } from "@mui/material";
// import IntroVideo from "./components/IntroVideo";
// import Slider2 from "./components/Slider2";
// import Introduce from "./components/Introduce";
import Title from "../../components/Title";
import Member from "./components/Member";
// import Location from "./components/Location";
// import Preview from "./components/Preview";
// import Links from "../../components/Links";
import { Helmet } from "react-helmet-async";
// import Subject from "./components/Subject";
// import Equip2 from "./components/Equip2";
// import Equip from "./components/Equip";
// import Example from "./components/Example";
// import Subject2 from "./components/Subject2";
// import Youtube from "./components/Youtube";
// import Notice from "./components/Notice";
// import Notice2 from "./components/Notice2";
// import Slider from "./components/Slider";
// import SubjectAll from "./components/SubjectAll";
// import Review from "./components/Review";
// import Popup from "./components/Popup";

import img from "../../images/title/263A0102.png";
import prideImg from "../../images/wj/DSC07315.png";

function Skymedicaldoctor() {
  return (
    <>
      <Helmet>
        <title>원주스카이동물메디컬센터</title>
        <meta
          name="description"
          content={"원주스카이동물메디컬센터 홈페이지입니다."}
          data-react-helmet="true"
        />
        <meta
          property="og:description"
          content={"원주스카이동물메디컬센터 홈페이지입니다."}
          data-react-helmet="true"
        />
      </Helmet>
      <Title img={img} title="의료진 소개" />
      {/* <Popup open={true} /> */}
      {/*
      <IntroVideo />
      <Introduce />
      <Youtube />
      <Review />
      */}
      <Member />

    <Section6>
        <div className="text-box">
        <Typography
            className="title"
            sx={{ color: "#ccc", opacity: "0.8" }}
            gutterBottom
        >
            SKYAMC PRIDE
        </Typography>
        <Typography
            className="sub-title"
            sx={{ color: "#fff" }}
            gutterBottom
        >
            각 분야의 전문성이 모여, 더 나은 진료를 만듭니다.
        </Typography>
        <Typography
            className="des"
            sx={{ color: "#fff", whiteSpace: "pre-wrap" }}
            gutterBottom
        >
반려동물의 질환은 여러 원인이 복합적으로 나타나는 경우가 많아, 한 분야의 진료만으로는 정확한 판단이 어려울 수 있습니다.<br />
원주SKY동물메디컬센터는 영상진단센터, 정형센터, 내과질환센터, 응급질환센터, 피부·호르몬센터, 안과센터 등
각 분야의 의료진이 함께 반려동물의 상태를 살피고 치료 방향을 논의합니다.<br />
진료 분야별 전문성과 체계적인 협진을 바탕으로, 반려동물에게 필요한 진료와 치료를 제공하기 위해 노력하고 있습니다.
        </Typography>
        </div>
        <img src={prideImg} alt="pride-img" />
    </Section6>
      {/*

      <Subject />
      <Equip2 />
      <Equip />
      <Subject2 />
      <Location />
      <Preview />

      <Notice2 /> */}
    </>
  );
}

const Section1 = styled.section`
  && {
    margin-top: calc(100vw * (120 / 1580));
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 768px) {
    && {
      flex-direction: column;
    }
  }
`;

const Section6 = styled(Section1)`
  && {
    width: 100%;
    height: fit-content;
    justify-content: start;
    align-items: center;
    background-color: #222;
    position: relative;
    margin: calc(100vw * (120 / 1580)) 0;
    > div.text-box {
      width: 50%;
      height: 100%;
      padding: calc(100vw * (50 / 1580));
    }
    > img {
      width: 50%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      right: 0;
      filter: grayscale() brightness(0.5);
    }
    .title {
      font-size: 50px;
      font-weight: 700;
    }
    .sub-title {
      font-size: 30px;
      font-weight: 700;
    }
    .des {
      font-size: 20px;
      font-weight: 400;
    }
  }
  @media screen and (max-width: 768px) {
    && {
      div.text-box {
        width: 100%;
        padding: calc(100vw * (100 / 1580));
      }
      img {
        display: none;
      }
      .title {
        font-size: calc(100vw * (24 / 390));
      }
      .sub-title {
        font-size: calc(100vw * (18 / 390));
      }
      .des {
        font-size: calc(100vw * (12 / 390));
      }
    }
  }
  @media screen and (min-width: 767px) and (max-width: 1500px) {
    && {
      .title {
        font-size: calc(100vw * (38 / 1240));
      }
      .sub-title {
        font-size: calc(100vw * (18 / 1240));
      }
      .des {
        font-size: calc(100vw * (16 / 1240));
      }
    }
  }
`;

export default Skymedicaldoctor;
